import { useMutation, useQuery } from 'react-query';

export const useMutateApi = ({
  key,
  fetch,
  retry = false,
  onSuccess,
  onError,
  allResponse = false,
}) => {
  const { data, isLoading, mutate, mutateAsync, error, isError } = useMutation(
    fetch,
    {
      mutationKey: JSON.stringify(key),
      retry,
      onSuccess: (res, payload) =>
        onSuccess && onSuccess(allResponse ? res : res?.data, payload),
      onError,
    }
  );
  return {
    response: data,
    data: data?.data,
    isLoading,
    mutate,
    mutateAsync,
    error,
    isError,
  };
};

export const useGetApi = ({
  key,
  fetch,
  enabled = true,
  retry = false,
  refetchOnWindowFocus = false,
  keepPreviousData = true,
  onSuccess,
  onError,
  allResponse = false,
}) => {
  const { data, isLoading, isFetching, refetch, isError, error } = useQuery({
    queryKey: JSON.stringify(key),
    queryFn: fetch,
    enabled,
    retry,
    refetchOnWindowFocus,
    keepPreviousData,
    onSuccess: (res, payload) =>
      onSuccess && onSuccess(allResponse ? res : res?.data, payload),
    onError,
  });
  return {
    response: data,
    data: data?.data,
    isLoading,
    isFetching,
    refetch,
    isError,
    error,
  };
};
